export class APIError extends Error {
    constructor(
      message: string,
      public statusCode: number,
      public error: string,
    ) {
      super(message);
      this.name = "APIError";
    }
  }
  